import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API_TOKEN = process.env.REACT_APP_API_TOKEN;

function MoreFieldNotes({ fieldNoteId }) {
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    let cancelled = false;

    if (!fieldNoteId) {
      setNotes([]);
      return () => {
        cancelled = true;
      };
    }

    const load = async () => {
      try {
        const url = `${process.env.REACT_APP_API_FOLDER}list_related_fieldnotes/?id=${encodeURIComponent(
          fieldNoteId
        )}`;
        const response = await axios.get(url, {
          headers: { "X-API-TOKEN": API_TOKEN },
        });
        if (!cancelled) {
          setNotes(Array.isArray(response.data) ? response.data.slice(0, 3) : []);
        }
      } catch (error) {
        // Discovery is supplementary; do not interfere with the article.
        console.error("Failed to load related Field Notes:", error);
        if (!cancelled) setNotes([]);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [fieldNoteId]);

  // Do not pad a weak recommendation section with a single result.
  if (notes.length < 2) return null;

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="row">
      <div className="col-lg-9">
        <section className="fieldnote-more-notes" aria-labelledby="fieldnote-more-notes-title">
          <h2 id="fieldnote-more-notes-title">More Field Notes</h2>
          <div className="fieldnote-more-notes-list">
            {notes.map((note) => (
              <article className="fieldnote-more-note" key={note.id}>
                <Link className="fieldnote-more-note-title" to={note.url} onClick={scrollTop}>
                  {note.title}
                </Link>
                <span className="fieldnote-more-note-author">
                  by{" "}
                  <Link to={note.author_url} onClick={scrollTop}>
                    {note.name}
                  </Link>
                </span>
              </article>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default MoreFieldNotes;
